// errors sourced from: https://blog.logrocket.com/understanding-resolving-metamask-error-codes/

export enum MetamaskErrors {
  Rejection = 4001,
}
